(function () {
  class PriceInputs {
     inputs = [
      'msrp_minus_40_',
      'wholesale_minus_4',
      'wholesale_price',
      'direct_to_employee',
      'msrp_minus_10_',
      'msrp_minus_20_',
      'msrp_minus_30_',
      'msrp_wholesale_case',
      'msrp_minus_5_',
      'msrp_sale_price'
    ];

    constructor() {
    }

    /**
     * Add hidden inputs for discounted prices to the Add to cart from.
     *
     * @param {HTMLFormElement} form
     * @param {Product} product
     */
    addPriceInputs = (form, product) => {
      for (const key of this.inputs) {
        const name = `properties[_${key}]`;
        const value = product.meta.pricing[key];
        let input = form.elements[name];

        if (input) {
          if (value > 0) {
            input.value = value;
          } else {
            input.remove();
          }
        } else if (value > 0) {
          input = this.createPriceInput(name, value);
          form.appendChild(input);
        }
      }
    }

    createPriceInput(name, value) {
      const input = document.createElement('input');
      input.name = name;
      input.value = value;
      input.hidden = true;
      return input;
    }
  }

  try {
    const priceInputs = new PriceInputs();
    window.addPriceInputs = priceInputs.addPriceInputs
  } catch (err) {
    console.error(err);
  }
})();
